import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Snooze = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.1187 2.00003C8.37936 1.99608 8.43646 2.34976 8.2107 2.48011C7.33849 2.98367 6.6449 3.66748 6.16018 4.44053C6.06903 4.58591 5.98526 4.73444 5.90908 4.88552C5.19379 6.30414 5.14754 7.94763 5.93698 9.31499C6.72638 10.6823 8.17269 11.4639 9.75878 11.5539C9.9278 11.5635 10.0984 11.5652 10.27 11.5589C11.1818 11.5257 12.1208 11.2669 12.993 10.7633C13.2187 10.633 13.4964 10.8593 13.3627 11.083C13.3316 11.135 13.2997 11.1866 13.2669 11.2378C12.766 12.0207 12.0752 12.6984 11.2147 13.1952C10.8689 13.3949 10.5115 13.5562 10.1474 13.6805C7.49019 14.5876 4.47651 13.523 3.01948 10.9993C1.56239 8.47559 2.14739 5.33321 4.2618 3.48554C4.55141 3.23247 4.86971 3.00368 5.21539 2.80411C6.07586 2.30731 7.00825 2.0479 7.93672 2.00556C7.9974 2.00279 8.05807 2.00095 8.1187 2.00003Z"
        fill="currentColor"
      />
      <path
        d="M10.1485 3.27325C9.80332 3.27325 9.5235 3.55308 9.5235 3.89825C9.5235 4.24343 9.80332 4.52325 10.1485 4.52325H11.7911L9.81979 6.79679C9.41273 7.26624 9.74621 7.99674 10.3676 7.99674H13.1602C13.5054 7.99674 13.7852 7.71691 13.7852 7.37174C13.7852 7.02656 13.5054 6.74674 13.1602 6.74674H11.5176L13.4889 4.4732C13.896 4.00375 13.5625 3.27325 12.9412 3.27325H10.1485Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Snooze;
